import React from "react";
import { observer } from "mobx-react";
import "./SettingsTab.scss";

const SettingsTab = () => <div className="settings-tab">SETTINGS</div>;

export default observer(SettingsTab);
